import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DrButtonComponent, DrCardComponent } from '@datarailsshared/datarailsshared';
import { PlgTokenService } from '../../services/plg-token.service';

@Component({
    selector: 'app-unauthenticated-landing',
    standalone: true,
    imports: [DrCardComponent, DrButtonComponent],
    templateUrl: './unauthenticated-landing.component.html',
    styleUrls: ['./unauthenticated-landing.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthenticatedLandingComponent {
    private readonly plgToken = inject(PlgTokenService);

    handleSignUp(): void {
        this.plgToken.goToMarketing();
    }
}
